import { Col, Row } from 'antd';
import {
  CustomButton,
  CustomTable,
  CustomText,
  FormInput,
} from '../../../../../components';
import { useEffect, useState } from 'react';
import { GoodTypes } from '../../../types';

const GestorTableItems = ({
  detailData,
  setDetailData,
  setModalManageAll,
  columnsFijos,
  columnsBienes,
  onSelectedRowsChange,
  goodsType,
  isManage,
  isNotView,
}: any) => {
  const [filtered, setFiltered] = useState('');
  const [filteredItems, setFilteredItems] = useState<any>([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);

const filterItems = async(e: any) => {
    const filterValue = e.target.value.toLowerCase();
    setFiltered(filterValue);
    const items = await detailData || [];
    
    const filter = items?.filter((it: any) => {
      if (!filterValue) return true;

      return (
        it?.product_code?.toLowerCase()?.includes(filterValue || '') ||
        it?.plate_code?.toLowerCase()?.includes(filterValue || '') ||
        (it?.item?.code?.toLowerCase() + ' - ' + it?.item?.name?.toLowerCase())?.includes(filterValue || '')
      );
    });
  
    setFilteredItems(filter);
  };
  
  
  const handleModalSomeItemsOpen = () => {
    setModalManageAll(true);
    if (onSelectedRowsChange) {
      onSelectedRowsChange(selectedRowKeys);
    }
  };

  const handleDeleteSelectedItems = () => {
    const filterItems = detailData.filter((item: any) => !selectedRowKeys.includes(item.id))
    setDetailData(filterItems);
    onSelectedRowsChange([]);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedKeys: React.Key[]) => {
      setSelectedRowKeys(selectedKeys);
    },
  };

  useEffect(() => {
    setFilteredItems(detailData || []);
  }, [detailData]);

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={12}>
        <CustomText
            strong={true}
            fontSize="big"
            text={`Listado solicitudes de ${(goodsType === GoodTypes.ACTIVO_FIJO) ? 'activos' : 'bienes' }`}
          />
        </Col>
        <Col span={12}>
          <FormInput
            label="Buscador"
            name="search"
            placeholder="Buscador por items en el listado"
            value={filtered}
            onChange={(e) => filterItems(e)}
          />
         {!isNotView && goodsType === GoodTypes.ACTIVO_FIJO && <span style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
            <CustomButton
              style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}
              label="Gestionar selección"
              onClick={() => handleModalSomeItemsOpen()}
              size="middle"
              disabled={selectedRowKeys.length === 0}
            />
            <CustomButton
              style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}
              label="Eliminar selección"
              onClick={() => handleDeleteSelectedItems()}
              size="middle"
              disabled={selectedRowKeys.length === 0}
            />
          </span>}
        </Col>
      </Row>

      {goodsType === GoodTypes.ACTIVO_FIJO ? (
        <Row>
          <Col xs={24}>
            <CustomTable
              columns={columnsFijos as any}
              dataSource={filteredItems}
              scroll={{ x: 'max-content' }}
              rowKey="id"
              rowSelection={isManage ? rowSelection : undefined}
            />
          </Col>
        </Row>
      ) : (
        <Row>
          <Col xs={24}>
            <CustomTable
              columns={columnsBienes as any}
              dataSource={filteredItems}
              scroll={{ x: 'max-content' }}
              rowKey="id" 
            />
          </Col>
        </Row>
      )}
    </>
  );
};

export default GestorTableItems;
